<div class="container">
    <div *ngIf="loadBestSales" id="loadingPage"></div>
    <div class="row fam bestSales">
        <ng-container>
            <div class="col-xs-6 fam-c" *ngFor="let product of bestSalesProduct;let i=index">
                <product (OnPersonalize)="PersonalizeModal(i)" (OnAdd)="addElementToBasket(i)" [product]="product"></product>
            </div>
        </ng-container>
    </div>
    <div>
        <div class="alert alert-danger text-center" *ngIf="!loadBestSales  && bestSalesProduct.length==0">
            Aucun produit disponible
        </div>
    </div>
</div>